import type React from 'react'
import { useIntl } from 'react-intl'

import {
  PromotionPlacementRowForm,
  type PromotionPlacementRowFormProps,
  type RegionPlacementConfiguration,
} from './PromotionPlacementRowForm'

export interface PromotionPlacementsFormProps extends Pick<PromotionPlacementRowFormProps, 'onPlacementChange'> {
  regions: RegionPlacementConfiguration[]
}

export const PromotionPlacementsForm: React.FC<PromotionPlacementsFormProps> = ({
  regions = [],
  onPlacementChange,
}) => {
  const intl = useIntl()

  return (
    <div className="flex flex-col gap-4">
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
        <div className="flex flex-col">
          <div className="grid h-16 grid-cols-[1fr_repeat(6,120px)] border-b border-gray-200 bg-gray-50 text-xs font-bold text-gray-900">
            <p className="flex items-start p-4">
              {intl.formatMessage({ id: 'promotions.placements.table.partnerName' })}
            </p>
            <p className="flex items-start justify-center p-4 text-center">
              {intl.formatMessage({ id: 'promotions.placements.table.email' })}
            </p>
            <p className="flex items-start justify-center p-4 text-center">
              {intl.formatMessage({ id: 'promotions.placements.table.milestone' })}
            </p>
            <p className="flex items-start justify-center p-4 text-center">
              {intl.formatMessage({ id: 'promotions.placements.table.hero' })}
            </p>
            <p className="flex items-start justify-center p-4 text-center">
              {intl.formatMessage({ id: 'promotions.placements.table.volunteerProfile' })}
            </p>
            <p className="flex items-start justify-center p-4 text-center">
              {intl.formatMessage({ id: 'promotions.placements.table.volunteerInfo' })}
            </p>
            <p className="flex items-start justify-center p-4 text-center">
              {intl.formatMessage({ id: 'promotions.placements.table.clientInfo' })}
            </p>
          </div>

          {regions.map((region) => (
            <div key={region._id} className={'border-t border-gray-200'}>
              <PromotionPlacementRowForm region={region} onPlacementChange={onPlacementChange} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
